import React, { ReactNode, useMemo } from 'react';
import { Tabs as MuiTabs } from '@mui/material';
import styled from '@emotion/styled';
import { useTab } from '@/contexts/tabs/tab-list-context';
import useAnalytics, { eventName } from '@/hooks/use-analytics';

interface TabListProps {
  children: ReactNode;
  tabListId: string;
}

function getFirstTabId(children: ReactNode): number {
  const array = React.Children.toArray(children) as React.ReactElement<{ tabId: number }>[];
  return array.length > 0 && typeof array[0].props.tabId === 'number' ? array[0].props.tabId : 0;
}

function TabList({ children, tabListId }: TabListProps) {
  const { trackEvent } = useAnalytics();
  const initialTabId = useMemo(() => getFirstTabId(children), [children]);
  const [activeTabId, setActiveTabId] = useTab(tabListId, initialTabId);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    trackEvent(`${eventName(tabListId)}_TAB_${newValue + 1}_SELECTED`);
    setActiveTabId(newValue);
  };

  return (
    <ListContainer
      value={activeTabId}
      onChange={handleChange}
      variant='fullWidth'
      scrollButtons='auto'
    >
      {children}
    </ListContainer>
  );
}

const ListContainer = styled(MuiTabs)`
  border-bottom: 1px solid #e0e0e0;
`;

export { TabList };
